import { UNIT_MONTHS, childNcpFraction, type Child, type TimeshareUnit } from '@divorceos/schema';

/** Child's time with the NCP as a percent 0..100. */
export function childNcpPercent(ch: Child): number {
  return childNcpFraction(ch, UNIT_MONTHS) * 100;
}

/** Units of `unitType` per `baseUnit` that represent `percent` of the time. */
export function percentToUnits(percent: number, unitType: TimeshareUnit, baseUnit: TimeshareUnit): number {
  const f = Math.max(0, Math.min(100, percent)) / 100;
  return (f * UNIT_MONTHS[baseUnit]) / UNIT_MONTHS[unitType];
}

/** Select % semantics: back-fill units as DAYS per YEAR. */
export function timeshareFromPercent(percent: number): Child['timeshare'] {
  return { units: Math.round(percentToUnits(percent, 'DAY', 'YEAR') * 100) / 100, unitType: 'DAY', baseUnit: 'YEAR' };
}

export function timeshareFromDays(days: number): Child['timeshare'] {
  return { units: days, unitType: 'DAY', baseUnit: 'YEAR' };
}
